import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    primary: 'var(--pure_color)',
    secondary: 'var(--color)'
  },
}));

export default function Certifications() {
  const classes = useStyles();

  return (
    <List className={classes.root}>

      
      <Typography variant="h5" color="textPrimary" component="h3">
        Machine Learning and Deep Learning
      </Typography>


      <a href="https://www.coursera.org/account/accomplishments/certificate/MJ26SE5GEURU" target="_blank">
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <img src="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/coursera.jpg" width="100%"></img>
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Neural Networks and Deep Learning" secondary="deeplearning.ai" />
      </ListItem>
      </a>
      <Divider variant="inset" component="li" />

      <a href="https://www.coursera.org/account/accomplishments/verify/F8B9EFMG82GF" target="_blank">
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <img src="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/coursera.jpg" width="100%"></img>
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Machine Learning" secondary="Stanford University" />
        </ListItem>
      </a>
      
      
      <Divider/>
      <Typography variant="h5" color="textPrimary" component="h3">
        Programming
      </Typography>
      
      <a href="https://www.coursera.org/account/accomplishments/verify/PBV5R98DRQXU" target="_blank">
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <img src="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/coursera.jpg" width="100%"></img>
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Algorithms" secondary="University of California San Diego, National Research University Higher School of Economics" />
      </ListItem>
      </a>
      
      <Divider variant="inset" component="li" />
      
      <a href="https://www.coursera.org/account/accomplishments/verify/HU4CTPU4GQZF" target="_blank">
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <img src="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/coursera.jpg" width="100%"></img>
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Data Structures" secondary="University of California San Diego, National Research University Higher School of Economics" />
      </ListItem>
      </a>
      
      <Divider variant="inset" component="li" />
      
      <a href="https://www.coursera.org/account/accomplishments/verify/48JLX5H746PA" target="_blank">
        <ListItem>
        <ListItemAvatar>
          <Avatar>
            <img src="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/coursera.jpg" width="100%"></img>
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Algorithms on Graphs" secondary="University of California San Diego, National Research University Higher School of Economics" />
      </ListItem>
      </a>
      
      <Divider variant="inset" component="li" />

      <a href="https://www.coursera.org/account/accomplishments/certificate/UFYJQ6MXEDKN" target="_blank">
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <img src="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/coursera.jpg" width="100%"></img>
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Competitive Programmer's Core Skills" secondary="Saint Petersburg State University" />
      </ListItem>
      </a>
      
      <Divider/>
      <Typography variant="h5" color="textPrimary" component="h3">
        Development
      </Typography>

      <a href="https://university.mongodb.com/course_completion/0031c8b3-bcb1-451d-b416-060f1118/printable" target="_blank">
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <img src="https://github.com/umakantv/info/blob/gh-pages/images/mongodb.jpg?raw=true" width="100%"></img>
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="MongoDB" secondary="MongoDB University" />
      </ListItem>
      </a>
      
      <Divider/>
      <Typography variant="h5" color="textPrimary" component="h3">
        Mathematics
      </Typography>

      <a href="https://www.coursera.org/account/accomplishments/certificate/PHBVFH7MEYM7" target="_blank">
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <img src="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/coursera.jpg" width="100%"></img>
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Combinatorics and Probability" secondary="University of California San Diego, National Research University Higher School of Economics" />
      </ListItem>
      </a>
      
      <Divider variant="inset" component="li" />

      <a href="https://matlabacademy.mathworks.com/progress/share/certificate.html?id=be8d4cb8-509b-4757-b776-dc0579893304" target="_blank">
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <img src="https://github.com/umakantv/info/blob/gh-pages/images/matlab.png?raw=true" width="100%"></img>
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="MatLab OnRamp" secondary="Matlab Academy" />
      </ListItem>
      </a>

      
    </List>
  );
}
